import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFeedBack } from '@/services/tip';

export const getFeedBack = createAsyncThunk('tip/fetchFeedBack', fetchFeedBack);

export const feedbackSlice = createSlice({
  name: 'feedback',

  initialState: [],

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getFeedBack.fulfilled, (state, { payload }: any) => {
      if (!payload) {
        return [];
      }
      state = payload;
      return state;
    });
  },
});

export const { } = feedbackSlice.actions;

export default feedbackSlice.reducer;
